import React from "react";
import { Container } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Policies.css";

const AboutPage = () => (
  <>
    <Navbar />
    <main className="hn-policies-main">
      <Container className="py-4 py-md-5">
        <h1 className="hn-policies-title">About us</h1>
        <div className="hn-policies-body">
          <p>
            Hosting Noodle was founded in 2026 with a simple vision: to make powerful, reliable hosting accessible without the usual complexity. We believe in serving infrastructure the way it should be—straightforward, dependable, and backed by real support.
          </p>
          <p>
            Our name reflects how we work. Like a good noodle, we aim to be flexible where you need flexibility and strong where you need strength. We offer bare metal servers, virtual servers, and DevOps services so you can choose exactly what fits your project—whether you need raw compute, cloud-style scaling, or a dedicated professional to deploy and manage your environments.
          </p>
          <p>
            We are committed to transparency, clear pricing, and a 97% uptime target. When something goes wrong, we aim to fix it. When you have questions, we aim to answer them. Hosting the Noodle Way means we focus on what matters: your workloads running smoothly, your data secure, and your team unblocked.
          </p>
          <p>
            Thank you for considering Hosting Noodle. We are here to help you build and run what matters.
          </p>
        </div>
      </Container>
    </main>
    <Footer />
  </>
);

export default AboutPage;
